import React, { useEffect } from "react";

import { Field, FieldArray } from "formik";

import { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { IoTrash } from "react-icons/io5";

import {
  Flex,
  Text,
  Divider,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Select,
  Button,
  HStack,
  Icon,
} from "@chakra-ui/react";

import ErrorMessage from "../../../../../components/CustomErrorMessage";
import CustomArrayInput from "../../../../../components/CustomArrayInput";
import CustomDatepickerArray from "../../../../../components/CustomDatepickerArray";
import { forNames } from "../../../../../utils/masks";

const SupervisaoOGMunicipal = ({ formProps, hasUnfinished }) => {
  useEffect(() => {
    setDefaultLocale("pt-br");
    registerLocale("pt-br", pt);
  }, []);

  return (
    <Flex
      flexDir="column"
      bgColor="#FFF"
      p="20px"
      borderRadius="16px"
      mt="20px"
    >
      <Text
        color={"#169499"}
        fontWeight="700"
        fontSize="16px"
        lineHeight="21.6px"
        textTransform="uppercase"
      >
        Supervisão do Órgão Gestor Municipal
      </Text>
      <Divider orientation="horizontal" mt="10px" />
      <Grid
        templateColumns={{ base: "repeat(1, 1fr)", lg: "repeat(2, 1fr)" }}
        gap="20px"
        rowGap="15px"
        mt="20px"
      >
        <GridItem colSpan={1}>
          <Field name="possuiSupervisaoOGMunicipal">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.possuiSupervisaoOGMunicipal &&
                  form.touched.possuiSupervisaoOGMunicipal
                }
                id="possuiSupervisaoOGMunicipal"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="possuiSupervisaoOGMunicipal"
                >
                  Possui Supervisão do Órgão Gestor Municipal?*
                </FormLabel>
                <Select
                  {...field}
                  h="42px"
                  name="possuiSupervisaoOGMunicipal"
                  id="possuiSupervisaoOGMunicipal"
                  placeholder="Selecione"
                  backgroundColor="white"
                  // isDisabled={hasUnfinished}
                >
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </Select>
                <FormErrorMessage>
                  {form.errors.possuiSupervisaoOGMunicipal}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
      </Grid>
      {formProps.values.possuiSupervisaoOGMunicipal === "S" && (
        <>
          <FieldArray name="listaSupervisaoOrgaoGestor">
            {(arrayHelpers) => (
              <>
                {formProps.values.listaSupervisaoOrgaoGestor &&
                formProps.values.listaSupervisaoOrgaoGestor.length > 0 ? (
                  formProps.values.listaSupervisaoOrgaoGestor.map(
                    (entidade, index) => (
                      <Grid
                        key={index}
                        templateColumns={{
                          base: "repeat(1, 1fr)",
                          lg: "repeat(3, 1fr)",
                        }}
                        gap="20px"
                        rowGap="15px"
                        mt="20px"
                      >
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <CustomArrayInput
                            name={`listaSupervisaoOrgaoGestor[${index}].nomeSupervisor`}
                            label={"Supervisor do Órgão Gestor Municipal*"}
                            placeholder={"Informe o Nome do Supervisor"}
                            maxLength={255}
                            onChange={(e) =>
                              formProps.setFieldValue(
                                `listaSupervisaoOrgaoGestor[${index}].nomeSupervisor`,
                                forNames(e.target.value)
                              )
                            }
                          />
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoOrgaoGestor[${index}].nomeSupervisor`}
                            />
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <CustomDatepickerArray
                            name={`listaSupervisaoOrgaoGestor[${index}].dataInicio`}
                            arrayFieldName={"listaSupervisaoOrgaoGestor"}
                            index={index}
                            fieldName={"dataInicio"}
                            label={"Início da Supervisão*"}
                            placeholder={"DD/MM/AAAA"}
                          />
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoOrgaoGestor[${index}].dataInicio`}
                            />
                          </Text>
                        </GridItem>
                        <GridItem colSpan={1} d="flex" flexDir="column">
                          <HStack spacing="10px" alignItems="flex-end">
                            <CustomDatepickerArray
                              name={`listaSupervisaoOrgaoGestor[${index}].dataFim`}
                              arrayFieldName={"listaSupervisaoOrgaoGestor"}
                              index={index}
                              fieldName={"dataFim"}
                              label={"Fim da Supervisão (se houver)"}
                              placeholder={"DD/MM/AAAA"}
                            />
                            <Icon
                              d={index === 0 ? "none" : "block"}
                              aria-label="Excluir estatuto"
                              color="#9EA1AE"
                              as={IoTrash}
                              boxSize="25px"
                              _hover={{ cursor: "pointer" }}
                              onClick={() => arrayHelpers.remove(index)}
                              marginBottom="8px !important"
                            />
                          </HStack>
                          <Text color="#e53e3e" fontSize="12px">
                            <ErrorMessage
                              name={`listaSupervisaoOrgaoGestor[${index}].dataFim`}
                            />
                          </Text>
                        </GridItem>
                      </Grid>
                    )
                  )
                ) : (
                  <div />
                )}
                <Button
                  id="button-adicionar-supervisao-municipal"
                  mt="15px"
                  mb="15px"
                  w="max-content"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={500}
                  fontSize="13px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={() => {
                    arrayHelpers.push({
                      id: 0,
                      nomeSupervisor: "",
                      dataInicio: "",
                      dataFim: "",
                    });
                  }}
                >
                  Adicionar
                </Button>
              </>
            )}
          </FieldArray>
        </>
      )}
    </Flex>
  );
};

export default SupervisaoOGMunicipal;
